import { render } from "./cp_zanlist.vue?vue&type=template&id=68a2598d&scoped=true"
import script from "./cp_zanlist.vue?vue&type=script&lang=js"
export * from "./cp_zanlist.vue?vue&type=script&lang=js"

import "./cp_zanlist.vue?vue&type=style&index=0&id=68a2598d&scoped=scoped&lang=less"

import exportComponent from "H:\\高报云\\HZY\\Code\\HZY.Student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a2598d"]])

export default __exports__